(function () {
	let resizeRafId = null;

	function waitForCollectionTabsImage(img) {
		if (!img) {
			return Promise.resolve();
		}

		if (img.complete && img.naturalWidth > 0) {
			return Promise.resolve();
		}

		return new Promise((resolve) => {
			const onDone = () => {
				img.removeEventListener('load', onDone);
				img.removeEventListener('error', onDone);
				resolve();
			};

			img.addEventListener('load', onDone, { once: true });
			img.addEventListener('error', onDone, { once: true });
		});
	}

	function preloadCollectionTabsImages(container) {
		const images = Array.from(container.querySelectorAll('.collection-list img')).filter((img) => {
			return img.currentSrc || img.getAttribute('src') || img.getAttribute('srcset');
		});

		if (!images.length) {
			return Promise.resolve();
		}

		return Promise.all(images.map((img) => waitForCollectionTabsImage(img)));
	}

	function initializeCollectionTabsReveal(container) {
		if (!container) {
			container = document.querySelector('.collection-list-wrapper');
		}
		if (!container) {
			return;
		}

		const tabs = container.querySelectorAll('.collection-tabs-container');

		if (!tabs.length) {
			return;
		}

		tabs.forEach((tab) => {
			const revealToken = `${Date.now()}-${Math.random().toString(16).slice(2)}`;
			tab.dataset.gridRevealToken = revealToken;
			tab.classList.add('loading', 'loading-images');

			requestAnimationFrame(() => {
				if (tab.dataset.gridRevealToken !== revealToken) {
					return;
				}

				tab.classList.remove('loading', 'loading-images');
			});
		});
	}

	function collectionTabs() {
		const collectionsTabs = document.querySelectorAll(".collection-tabs");

		if (collectionsTabs.length) {
			collectionsTabs.forEach(tabs => {
				const id = tabs.dataset.sectionId;
        const collectionTabsElement = document.getElementById(`shopify-section-${id}`);
	if (!collectionTabsElement) return;
        const collectionTabs = collectionTabsElement.querySelector('.collection-tabs');

        if (!collectionTabs) return;
	if (collectionTabs.dataset.tabsInitialized === 'true') return;
	collectionTabs.dataset.tabsInitialized = 'true';

        const collectionTabsWidth = window.innerWidth;
        const collectionTabsNavigation = collectionTabs.querySelectorAll('.navigation-item');
        const collectionTabsList = collectionTabs.querySelectorAll('.collection-tabs-list');
        const collectionTabsContainers = collectionTabs.querySelectorAll('.collection-tabs-container');

        const activateTab = (item) => {
          collectionTabsNavigation.forEach((element) => element.classList.remove('active'));
          item.classList.add('active');
 
          collectionTabsList.forEach((element) => element.classList.remove('active'));
          collectionTabsContainers.forEach((element) => element.classList.remove('active'));

          const tabId = item.dataset.tab;
          const activeList = collectionTabs.querySelector(`[data-tab-id="${tabId}"]`);
          activeList.classList.add('active');
          
          // Find the parent container and add active class
          const activeContainer = activeList.closest('.collection-tabs-container');
          if (activeContainer) {
            activeContainer.classList.add('active');
            // Re-initialize image preloading for this tab
            initializeCollectionTabsReveal(collectionTabsElement.querySelector('.collection-list-wrapper'));
          }
        };

        collectionTabsNavigation.forEach((item) => {
          item.addEventListener("click", () => activateTab(item));
        });

        if (collectionTabsWidth >= 1025) {
          collectionTabsNavigation.forEach((item) => {
            item.addEventListener("keyup", (event) => (event.key === "Enter" || event.key === "Space") && activateTab(item));
          });
        }
        
        // Initialize image preloading
        initializeCollectionTabsReveal(collectionTabsElement.querySelector('.collection-list-wrapper'));
      });
    }
  }

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', collectionTabs);
	} else {
		collectionTabs();
	}
  document.addEventListener('shopify:section:load', collectionTabs);
	window.addEventListener('resize', () => {
		if (resizeRafId) cancelAnimationFrame(resizeRafId);
		resizeRafId = requestAnimationFrame(() => {
			document.querySelectorAll('.collection-tabs').forEach((tabs) => {
				tabs.dataset.tabsInitialized = 'false';
			});
			collectionTabs();
			resizeRafId = null;
		});
	}, { passive: true });
})();